import React, {useRef} from "react"
import {DefaultTablePagination, Popconfirm, Table, Tooltip} from "../../../components/Elements/appUtils"
import {patientPaymentInFxn} from "../actions/patients";
import moment from "moment";

const PatientPaymentInList = (props) => {
    let tableRef = useRef()
    const apiRequest = (params) => {
        return new Promise(async (resolve) => {
            params.customerId = props.customerId;
            params.sortField = "_id"
            params.sortOrder = "descend"
            let resp = await patientPaymentInFxn(params);
            resolve(resp)
        })
    }
    const columns = [
        {
            title: "Client Name",
            dataIndex: "customerId",
            key: "customerId",
            render: (text, record) => <>{record?.customerId?.name}</>,
        },
        {
            title: "Amount",
            dataIndex: "amount",
            key: "amount",
        },
        {
            title: "Invoice Number",
            dataIndex: "invoiceNumber",
            key: "invoiceNumber",
        },
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
            render: (text, record) => <>{text ? (moment(text).format("l")) : null}</>,
            // render: (text, record) => <>{text ? (moment(text).format("l")) : (moment(record.createdAt).format("l"))}</>,
        }
    ];

    return (
        <div>
            <Table
                apiRequest={apiRequest}
                columns={columns}
                ref={tableRef}
                position={"top"}
                pagination={{...DefaultTablePagination(), defaultPageSize: 50}}

            />
        </div>
    )
}
export default PatientPaymentInList